import { enableProdMode, Injector, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { tdrsLoggerService } from './app/service/common/tdrs-logger.service';
import { tdrsErrorService } from './app/service/common/tdrs-error.service';
import {
  TdrsHttpEnvironmentService,
  TDRS_HTTP_ENVIRONMENT_CONFIG
} from './app/service/environment';

// Environments
//
import * as environments from './json/tdrs-environment.json';


const providers: StaticProvider[] = [
  { provide: tdrsLoggerService, useClass: tdrsLoggerService, deps: [] },
  { provide: tdrsErrorService, useClass: tdrsErrorService, deps: [] },
  {
    provide: TDRS_HTTP_ENVIRONMENT_CONFIG,
    useValue: JSON.parse(JSON.stringify(environments['default']))
  },
  { provide: TdrsHttpEnvironmentService, useClass: TdrsHttpEnvironmentService, deps: [TDRS_HTTP_ENVIRONMENT_CONFIG] }
];

// Create injector
const injector = Injector.create({ providers });

// Get services
const loggerService = injector.get(tdrsLoggerService);
const errorService = injector.get(tdrsErrorService);
const environmentSerivce = injector.get(TdrsHttpEnvironmentService);

// AppDynamics setup
if (environmentSerivce.getTag('app-dynamics') === true) {
  const appDynamicScript = `
    window['adrum-start-time'] = new Date().getTime();
    (function(config){
      config.appKey = '${environmentSerivce.getTag('dynamic')}';
      config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
      config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
      config.beaconUrlHttp = 'http://col.eum-appdynamics.com';
      config.beaconUrlHttps = 'https://col.eum-appdynamics.com';
      config.xd = {enable : false};
   adrum-config'] = {}));
  `;

  const script = document.createElement('script');
  script.charset = 'UTF-8';
  script.innerHTML = appDynamicScript;

  const scriptAppD = document.createElement('script');
  scriptAppD.charset = 'UTF-8';
  scriptAppD.src = '//cdn.appdynamics.com/adrum/adrum-4.5.5.1807.js';

  document.head.appendChild(script);
  document.head.appendChild(scriptAppD);
}

// Enable production mode if needed
if (environmentSerivce.name === 'Production') {
  enableProdMode();
}

// Bootstrap Angular app
platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => loggerService.error(errorService.getClientErrorMessage(err)));
